import React, { FC, memo, useState, useEffect } from 'react'
import classNames from 'classnames'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'

import { ITextAreaProps } from '../types'

import SC from '../base/Text.styles'

const {
  Block,
  TextareaWrapper,
  Textarea: StyledTextarea,
  Error,
  TopGradient,
  BottomGradient,
} = SC

/** Текстовый блок */
const TextArea: FC<ITextAreaProps> = (props) => {
  const {
    error,
    label = '',
    children,
    disabled,
    width = '100%',
    height = 120,
    onChange: onChangeFromProps = (arg) => arg,
    ...otherProps
  } = props
  const [isFocused, setIsFocused] = useState(false)
  const [labelClassName, setLabelClassName] = useState('')
  const [hasText, setHasText] = useState(false)

  const onFocus = (): void => {
    setIsFocused(true)
  }

  const onBlur = (): void => {
    setIsFocused(false)
  }

  const onChange = (event): void => {
    const { value } = event.target
    setHasText(value.length > 0)
    onChangeFromProps(value)
  }

  useEffect(() => {
    setLabelClassName(
      classNames({
        active: isFocused || hasText,
        disabled,
        error,
      })
    )
  }, [isFocused, disabled, hasText, error])

  const textAreaClassName = classNames({ error })

  return (
    <Block style={{ width }}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={labelClassName}>{label}</label>

      <TextareaWrapper style={{ height }}>
        <StyledTextarea
          className={textAreaClassName}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          {...otherProps}
        >
          {children}
        </StyledTextarea>

        <TopGradient />
        <BottomGradient />
      </TextareaWrapper>

      <Spacing spacing='xxsmall' />

      <Error>{error}</Error>
    </Block>
  )
}

export { TextArea }
export default memo(TextArea)
